import type { FundResponse } from '@cosvision/shared';
import { request } from '../api.js';

export interface ListFundsOptions {
  includeInactive?: boolean;
}

export function listFunds(opts: ListFundsOptions = {}): Promise<FundResponse[]> {
  return request<FundResponse[]>('get', '/funds', undefined, {
    params: opts.includeInactive ? { includeInactive: 'true' } : undefined,
  });
}

export function getFundById(id: string): Promise<FundResponse> {
  return request<FundResponse>('get', `/funds/${id}`);
}
